import { render, staticRenderFns } from "./TenantAppLayout.vue?vue&type=template&id=fd18c0a2&"
import script from "./TenantAppLayout.vue?vue&type=script&lang=js&"
export * from "./TenantAppLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports